import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgbDatepickerModule, NgbDropdownModule, NgbPopoverModule, NgbTooltipModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap'
import { MomentModule } from 'ngx-moment'
import { NgPipesModule } from 'ngx-pipes'

import { UtilCommonModule } from 'common/util/module'
import { LocaleModule } from 'common/locale/module'

import { CustomFieldInputComponent } from './components/customFieldInput.component'
import { CustomFieldRowComponent } from './components/customFieldRow.component'

export { CustomFieldsService } from './services/customFields.service'

@NgModule({
  imports: [
    CommonModule,
    UtilCommonModule,
    LocaleModule.forChild(),
    FormsModule,
    ReactiveFormsModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgbPopoverModule,
    NgbDatepickerModule,
    NgbTypeaheadModule,
    MomentModule,
    NgPipesModule,
  ],
  declarations: [
    CustomFieldInputComponent,
    CustomFieldRowComponent,
  ],
  exports: [
    CustomFieldInputComponent,
    CustomFieldRowComponent,
  ],
})
export class MediaCustomFieldsModule { }
